import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AdminLayout } from "./AdminLayout";

export const ProtectedRoute = ({ children }) => {
  const { user, checkAuth } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (user === false) checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center text-[#6F3F55]">Carregando...</div>;
  }
  if (user === false) {
    return <Navigate to="/admin/login" replace />;
  }
  if (user.must_change_password && location.pathname !== "/admin/senha") {
    return <Navigate to="/admin/senha" replace />;
  }
  return <AdminLayout>{children}</AdminLayout>;
};
